import * as React from "react"
const EmailInvite = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="#2E2E2E"
      d="M1.185 10.65v.017H11.26a.593.593 0 1 1 0 1.185H.593A.593.593 0 0 1 0 11.259V.593C0 .265.265 0 .593 0h16c.327 0 .592.265.592.593V7.11a.593.593 0 1 1-1.185 0V3.286l-3.64 2.83 1.647 1.357a.593.593 0 0 1-.754.915l-1.852-1.525-2.445 1.901a.593.593 0 0 1-.727 0L5.784 6.863 1.185 10.65Zm0-1.535 3.64-2.998-3.64-2.831v5.829Zm7.408-1.57L16 1.786v-.6H1.185v.6l7.408 5.76Zm5.63 5.84.47-.47a.593.593 0 0 1 .837.837l-1.481 1.482a.593.593 0 0 1-.838 0l-1.482-1.482a.593.593 0 1 1 .838-.838l.47.47v-.94A3.556 3.556 0 1 1 16.593 16a.593.593 0 1 1 0-1.185 2.37 2.37 0 1 0-2.37-2.37v.94Z"
    />
  </svg>
)
export default EmailInvite
